import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./Skills.css"

const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  return (
      <div className="skills" id="skills">
        <h1>Skills</h1>
        <Carousel responsive={responsive} infinite={true} className="image-slider">
          <div className="item">
            <h5>MERN Stack</h5>
          </div>
          <div className="item">
            <h5>React Native</h5>
          </div>
          <div className="item">
            <h5>C++</h5>
          </div>
          <div className="item">
            <h5>Java</h5>
          </div>
          <div className="item">
            <h5>JavaScript</h5>
          </div>
          <div className="item">
            <h5>Python</h5>
          </div>
  

        </Carousel>;
      </div>

  )
}

export default Skills